Controller = App.loadClass 'core::Angular/Controller'

class exports.SelectYearAndCropController extends Controller

    constructor: (@scope, @transitions, @repo) ->
        super(@scope, @transitions)

        # dialog-related scope stuff
        @scope.step.title = 'Select Year and Crop'
        @scope.step.previous = () -> # nothing to do
            undefined
        @scope.step.next = @next
        @scope.step.canContinue = @canContinue

        # stuff for years
        @scope.year_placeholder = 'Loading survey years...'
        @scope.years = []
        @scope.toggleYear = @toggleYear
        @scope.isYearSelected = @isYearSelected

        # stuff for spps
        # the dialog says "Crops", but it's actually showing placement programs
        @scope.spp_placeholder = 'Loading survey crops...'
        @scope.spps = []
        @scope.toggleSpp = @toggleSpp
        @scope.isSppSelected = @isSppSelected

        # initialize check for input changes
        @input_changed = false
        @scope.$watchCollection 'selected.years', (val, old_val) =>
            if val isnt old_val
                @input_changed = true
        @scope.$watchCollection 'selected.spps', (val, old_val) =>
            if val isnt old_val
                @input_changed = true

        # load data
        @loadYearsAndSpps()

    loadYearsAndSpps: () =>
        @repo.getYearsAndSpps().then (result) =>
            if result.data?.status?.type isnt 'success'
                if result.data?.status?
                    @scope.$parent.setAlert(result.data.status)
                else
                    @scope.$parent.setAlert
                        type: 'error'
                        msg: 'Failed to load survey years and crops'
                return

            @scope.years = result.data.data.years
            if @scope.years.length is 0
                @scope.year_placeholder = 'No survey years found'
            else
                # pre-select the first (usually current) one
                if @scope.selected.years.length is 0
                    @toggleYear(@scope.years[0])

            @scope.spps = result.data.data.spps
            if @scope.spps.length is 0
                @scope.spp_placeholder = 'No survey crops found'
            else
                # if there's only one, pre-select it
                if @scope.selected.spps.length is 0 and @scope.spps.length is 1
                    @toggleSpp(@scope.spps[0])

            @sanityCheck()

        , () =>
            # if the request failed
            @scope.$parent.setAlert
                type: 'error'
                msg: 'Failed to load survey years and crops'

    sanityCheck: () =>
        # this is just to make absolutely sure we don't have bad values
        # selected that aren't actually options (reverse for loop because we're
        # deleting things)
        for year in @scope.selected.years by -1
            if @scope.years.indexOf(year) is -1
                @toggleYear(year)

        for spp in @scope.selected.spps by -1
            if _.findIndex(@scope.spps, { id: spp.id }) is -1
                @toggleSpp(spp)

    next: () =>
        @scope.$parent.clearAlert()
        if @input_changed
            @scope.selected.survey_results = []
        @scope.goToStep('select_surveys')

    canContinue: () =>
        # need at least one year and one SPP selected to continue
        return @scope.selected.years.length > 0 and @scope.selected.spps.length > 0

    toggleYear: (year) =>
        i = @scope.selected.years.indexOf(year)
        if i is -1
            # year is not selected. add it to the array
            @scope.selected.years.push(year)
        else
            # year is selected. remove it from the array
            @scope.selected.years.splice(i, 1)

    isYearSelected: (year) =>
        return @scope.selected.years.indexOf(year) > -1

    toggleSpp: (spp) =>
        i = _.findIndex(@scope.selected.spps, { id: spp.id })
        if i is -1
            # spp is not selected. add it to the array
            @scope.selected.spps.push(spp)
        else
            # spp is selected. remove it from the array
            @scope.selected.spps.splice(i, 1)

    isSppSelected: (spp) =>
        return _.findIndex(@scope.selected.spps, { id: spp.id }) > -1
